<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { createComponent } from "vue-function-api";
import SubscReConnectComponent from "@/framework/components/SubscReConnect.vue";

export default createComponent({
  components: {
    SubscReConnectComponent,
  },
  setup(props, context) {},
});
</script>

<style>
.v-toolbar__title {
  width: 100%;
  text-align: center;
}
</style>
